import React from 'react'
import { BooleanCell } from '_/components/datagrid/boolean-cell'

export const WidgetsListColumns = [
  {
    field: 'title',
    headerName: 'Nome',
    minWidth: 500,
    flex: 1,
    editable: false,
  },
  {
    field: 'active',
    headerName: 'Ativo',
    sortable: true,
    editable: false,
    width: 200,
    renderCell: ({ value }) => <BooleanCell value={value} />,
  },
]
